export const TRACEPARENT_HEADER = 'traceparent';

/** A W3C Trace Context header value the browser originates: version 00, sampled. */
export function generateTraceparent(): string {
  return `00-${randomHex(16)}-${randomHex(8)}-01`;
}

// The spec forbids an all-zero trace-id or span-id; redraw on that (astronomically rare) result.
function randomHex(byteLength: number): string {
  const bytes = new Uint8Array(byteLength);
  do {
    crypto.getRandomValues(bytes);
  } while (bytes.every((byte) => byte === 0));

  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}
